import type { FC } from 'react';

import type { ModuleOrPlanActionOrgUnit } from 'src/types/orgUnit';
import { OrgTreeContextProvider } from 'src/components/common/OrgTree/OrgTreeContext';
import type { OrgTreeState } from 'src/components/common/OrgTree/types';
import { CHECKBOX_MODE } from 'src/components/common/OrgTree/types';

import OrgTreeMultiSelect from './components/OrgTreeMultiSelect';
import OrgTreeSingleSelect from './components/OrgTreeSingleSelect';

export interface OrgTreeProps {
  checkboxMode?: CHECKBOX_MODE | number;
  itemsAreDraggable?: boolean;
  orgUnitsFromPermission?: boolean;
  initialOrgUnits?: ModuleOrPlanActionOrgUnit[];
  moduleId?: number;
  orgTreeState: OrgTreeState;
  customFetchChildrenEndpoint?: (orgUnitId: number) => string;
  surveyIdOverride?: number;
  showPriorityLabels?: boolean;
  disableOrgUnitSelectionBasedOnStatus?: boolean;
  syncWithFilter?: boolean;
}

const OrgTree: FC<OrgTreeProps> = ({
  checkboxMode = CHECKBOX_MODE.NONE,
  itemsAreDraggable = false,
  orgUnitsFromPermission = false,
  initialOrgUnits,
  moduleId,
  orgTreeState,
  customFetchChildrenEndpoint,
  surveyIdOverride,
  showPriorityLabels,
  disableOrgUnitSelectionBasedOnStatus,
  syncWithFilter = true,
}) => (
  <OrgTreeContextProvider
    itemsAreDraggable={itemsAreDraggable}
    checkboxMode={checkboxMode}
    initialOrgUnits={initialOrgUnits}
    orgUnitsFromPermission={orgUnitsFromPermission}
    moduleId={moduleId}
    setNodes={orgTreeState.setNodes}
    setOrgUnitMap={orgTreeState.setOrgUnitMap}
    customFetchChildrenEndpoint={customFetchChildrenEndpoint}
    surveyIdOverride={surveyIdOverride}
    showPriorityLabels={showPriorityLabels}
    disableOrgUnitSelectionBasedOnStatus={disableOrgUnitSelectionBasedOnStatus}
  >
    {checkboxMode === CHECKBOX_MODE.MULTI ? (
      <OrgTreeMultiSelect
        itemsAreDraggable={itemsAreDraggable}
        orgTreeState={orgTreeState}
        syncWithFilter={syncWithFilter}
      />
    ) : (
      <OrgTreeSingleSelect
        itemsAreDraggable={itemsAreDraggable}
        orgTreeState={orgTreeState}
        checkboxMode={checkboxMode}
        syncWithFilter={syncWithFilter}
      />
    )}
  </OrgTreeContextProvider>
);

export default OrgTree;
